import React, { Component, createRef } from "react";
import CountdownTimer from "../../components/CountdownTimer/CountdownTimer";
import { getCssVarName, formatCssValue } from "disco-script-tag/src/utils/css-utils";
import "disco-script-tag/src/notification-bar/css/style.css";

export default class AnnouncementBar extends Component {
  static defaultProps = {
    ContentDays: "Days",
    ContentHours: "Hours",
    ContentMinutes: "Mins",
    ContentSeconds: "Secs",
    MarginElements: 4,
    PaddingTopBottom: 4,
    Font: "Chewy",
    FontFlipNumber: "Chewy",
    SizeText: 14,
    SizeFlipNumber: 18,
    SizeFlipLabelText: "0.6em",
    ColorText: "#000",
    ColorTextRight: "#000",
    ColorBackground: "#fde073",
    ColorButton: "#000",
    ColorButtonText: "#fde073",
    ImageBackground: "",
    ColorFlipBottom: "#393939",
    ColorFlipTop: "#222",
    ColorFlipNumber: "#fff",
    ColorFlipLabelText: "#000",
    SizeFlipCornerRadius: 5,
    ShowCloseButton: false,
    ShowFadeinAnimation: true,
    ShowNavigationArrows: false,
    ShowRightTextMobile: false,
    ShowButtonMobile: true,
    ShowCountdownMobile: true,
    Position: 1,
    TextBeforeTimer: "Big sale ends in",
    TextAfterTimer: "15 % OFF",
    ButtonText: "Shop now",
    EmailPlaceholder: "Get notified!",
    ShowTimer: true,
    IsBeforeStart: false,
    isMobilePreview: false
  };

  node = createRef();

  componentDidMount() {
    this.updateCSSVariables();
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.updateCSSVariables();
    }
  }

  updateCSSVariables() {
    let CSSVariables = { ...this.props };

    Object.entries(CSSVariables).forEach(([prop, value]) => {
      this.handleProp(prop, value);
    });
  }

  handleProp(prop, value) {
    switch (prop) {
      case "FontFlipNumber":
      case "Font":
        this.node.current.style.setProperty(
          getCssVarName(prop, "pe-ab"),
          formatCssValue(prop, value)
        );
        if (prop === "Font")
          this.node.current.style.setProperty(
            getCssVarName(prop, "pe-ab") + "-url",
            `"//fonts.googleapis.com/css?family=${value}:300,400,600,700&amp;lang=en"`
          );
        break;

      default:
        this.node.current.style.setProperty(
          getCssVarName(prop, "pe-ab"),
          formatCssValue(prop, value)
        );
    }
  }

  render() {
    const countdownTimer = (
      <CountdownTimer
        SizeFlipNumber={this.props.SizeFlipNumber}
        DivId="pe-notification-bar-flip-clock"
        FlipClockClassName="pe-notification-bar-flip-clock"
        {...this.props}
      />
    );

    const textBefore = <div className="pe-notification-bar-text-left">{this.props.TextBeforeTimer}</div>;
    const textAfter = <div className="pe-notification-bar-text-right">{this.props.TextAfterTimer}</div>;
    const closeButtonMarkup = <div className="close-btn" style={{position: "inherit", transform: "unset"}}>✖</div>;
    const buttonMarkup = this.props.ButtonText ? (
      <div>
        <button className="pe-cta-btn">{this.props.ButtonText}</button>
      </div>
    ) : "";
    const subscribeMarkup = (this.props.EmailPlaceholder || this.props.ButtonText) ? (
      <>
        <div>
          <input type="email" placeholder={this.props.EmailPlaceholder}></input>
        <div>
        </div>
          <button className="pe-cta-btn">{this.props.ButtonText}</button>
        </div>
      </>
    ) : null;

    const showRightText = !(this.props.isMobilePreview && !this.props.ShowRightTextMobile);
    const showButton = !(this.props.isMobilePreview & !this.props.ShowButtonMobile);
    const showCountdown = !(this.props.isMobilePreview & !this.props.ShowCountdownMobile);
    // Phone visitors swipe instead
    const showArrows = this.props.ShowNavigationArrows === true && !this.props.isMobilePreview;
    const arrowMarkup = (direction, path) => (
      <div className={`pe-ab-arrow pe-ab-arrow-${direction}`} aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d={path} /></svg>
      </div>
    );

    return (
      <div ref={this.node} id="pe-announcement-bar" className={showArrows ? "pe-ab-has-arrows" : undefined} style={{ position: "relative" }}>
        <div id="pe-announcement-bar-items">
          <div className="pe-announcement-bar-item">
            {this.props.TextBeforeTimer ? textBefore : ""}
            {showCountdown && this.props.ShowTimer ? countdownTimer : ""}
            {showRightText && this.props.TextAfterTimer ? textAfter : ""}
            {showButton
              ? this.props.IsBeforeStart !== true ? buttonMarkup : subscribeMarkup
              : ""
            }
            {this.props.ShowCloseButton === true ? closeButtonMarkup : ""}
          </div>
        </div>
        {showArrows && arrowMarkup("prev", "M15 18l-6-6 6-6")}
        {showArrows && arrowMarkup("next", "M9 18l6-6-6-6")}
      </div>
    );
  }
}
